export default "__VITE_ASSET__MZ3$4LnP__"